import React from "react";
import { Flex, Text, Spinner, Tooltip } from "@chakra-ui/react";
import useThemeColors from "../../../../hooks/useThemeColors";
import useCurrencySymbol from "../../../../hooks/useCurrencySymbol";

const BoxListItemNew = ({
  loading,
  label,
  data,
  bg,
  isPrice,
  color,
  noTooltip,
  currency,
}) => {
  // COLORS
  const { whiteMode, newBorderMode, textPrimaryMode } = useThemeColors();

  const currencySymbol = useCurrencySymbol(currency);

  return (
    <Flex
      w="100%"
      align="center"
      justify="space-between"
      bg={bg ? bg : whiteMode}
      p="0.5rem 0rem"
      borderTop={`1px solid ${newBorderMode}`}
      borderRadius="0rem"
    >
      {!loading ? (
        <>
          <Flex align="center">
            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top"
              fontSize="xs"
              label={label}
              isDisabled={noTooltip}
            >
              <Text
                fontSize="0.8rem"
                color={color ? color : textPrimaryMode}
                fontWeight="500"
                isTruncated
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                maxWidth="240px"
              >
                {label}
              </Text>
            </Tooltip>
          </Flex>
          <Flex align="center" justify="flex-end">
            <Text
              color={textPrimaryMode}
              fontSize="0.8rem"
              fontWeight="500"
              whiteSpace="nowrap"
            >
              {isPrice ? currencySymbol : ""} {data}
            </Text>
          </Flex>
        </>
      ) : (
        <Spinner size="md" color={textPrimaryMode} />
      )}
    </Flex>
  );
};

export default BoxListItemNew;
